import { Box, Img } from '@chakra-ui/react'
import React from 'react'

export const BlogMedia = (props) => {
  const { src, alt, ...rest } = props
  return (
    <Box
      pos="relative"
      cursor="pointer"
      className="group"
      h={{
        base: '18rem',
        lg: '16rem',
      }}
      overflow="hidden"
      {...rest}
    >
      <Img
        w="full"
        h="full"
        objectFit="cover"
        htmlWidth="672"
        htmlHeight="448"
        src={src}
        alt={alt}
        transition="all 0.2s"
        _groupHover={{
          transform: 'scale(1.05)',
        }}
        rounded={"md"}
      />
    </Box>
  )
}
